<template>
    <main-content>
        <action-bar>
            <router-link to="/online-factor-factor-create" class="btn btn-success">{{ 'ایجاد فاکتور' }}</router-link>
        </action-bar>
        <online-factor-filter :action="filterAction"></online-factor-filter>
        <div v-if="$can('read', 'payment-link')">
            <kt-datatable ref="datatable" v-bind="datatablePropsWithManage"></kt-datatable>
        </div>
        <div v-else>
            <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import Filter from './components/filter_factor.vue'
import { ShopApiUrl } from '@/common/api.service';
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from './datatable/columns_factors';
import manageColumns from './datatable/columnsWithManageAccess_factors';
import actionsColumn from './components/actions-column-factor.vue'
import actionsColumnWithManageAccess from './components/actions-column-factor.vue'
import actionBar from '@/components/custom/action-bar'

export default {
    name: 'customers',
    components:{
        'main-content': mainContent,
        'online-factor-filter': Filter,
        'action-bar': actionBar
    },
    data() {
       return {
           query: {}
       }
    },
    computed: {
        datatablePropsWithManage() {
            return {
                id: 'datatableWithManageAccess',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ShopApiUrl.path('factor?is_admin_panel=true'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: manageColumns,
                actions: actionsColumnWithManageAccess
            }
        },
        datatableProps() {
            return {
                id: 'datatable',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ShopApiUrl.path('factor'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },

}
</script>